<div class="row">
  <div class="col-sm p-2">
    <b>{{ label }}</b>
  </div>
  <div class="col-sm p-2 wrap-anywhere">
    <ng-content></ng-content>
  </div>
</div>